import styled, { css } from 'styled-components'

export const Pill = styled.strong<{ selected: boolean }>(
    ({ selected, theme }) => css`
        box-sizing: border-box;
        border-radius: ${theme.typography.border.radius.xxLarge};
        border: ${theme.typography.border.radius.xxxSmall} solid #0000001a;
        padding: ${theme.spacing.xSmall};
        margin: ${theme.spacing.xSmall} ${theme.spacing.xSmall} 0 0;
        font-size: ${theme.typography.font.size.small};
        line-height: ${theme.typography.font.size.xLarge};
        text-align: center;
        ${selected &&
        css`
            background-color: #2298da14;
            border: ${theme.typography.border.radius.xxxSmall} solid #2298da33;
        `}
    `,
)
